import { navigateToHeritageFunnel } from "@/helpers/heritage-integration/navigation-helper";

// Unsure if this is needed. I don't think its used anywhere
export async function heritageBeforeEnter(to, from) {
    await navigateToHeritageFunnel({ shouldSaveSession: false, pageNameToLog: to.name });
}
